import { render, staticRenderFns } from "./relevance-form-modal.vue?vue&type=template&id=a99cef0a&scoped=true&"
import script from "./relevance-form-modal.vue?vue&type=script&lang=ts&"
export * from "./relevance-form-modal.vue?vue&type=script&lang=ts&"
import style0 from "./relevance-form-modal.vue?vue&type=style&index=0&id=a99cef0a&prod&lang=less&scoped=true&"
import style1 from "./relevance-form-modal.vue?vue&type=style&index=1&id=a99cef0a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99cef0a",
  null
  
)

export default component.exports